
  import {defineComponent,PropType,computed,ref,Ref,inject} from "vue";
  import {StatusService} from "@/services/status.service";
  import {UserService} from "@/services/user.service";
  import {DeviceService} from "@/services/device.services";
  import {Device} from "@/models/devices.interface";


export default defineComponent({
   name: "SearchingBar",
   props:{
            
    },
    setup(props,context){

      let statusArray:Ref<string[]>=ref([]);
      let devicesArray:Ref<Device[]>=ref([]);
      let pagina=inject("pagina") as Ref<number>;

      let objSearch :Ref<Object> = ref({status:"",phone_number:"all",finicio:"",ffin:""});

      const serviceStatus= new StatusService();
      const serviceUser = new UserService();
      const serviceDevice = new DeviceService();

      const usuario = serviceUser.fetch();
      const fetchStatus = async()=>{statusArray.value= await serviceStatus.getAll(usuario.token);}
      
      const fetchDevices = async()=>{devicesArray.value = await serviceDevice.getAll(usuario.token);}
      fetchStatus();
      fetchDevices();
       
      const btnSearch = ()=>{pagina.value=1;context.emit("searchingsms",objSearch.value);};
      const btnExport = ()=>{context.emit("exportsms",objSearch.value)}

      return {statusArray,devicesArray,objSearch,btnSearch,btnExport}
    }//fin de setup
});
